import { computed } from 'vue';
import { useStore } from 'vuex';

import { GetOrganizationId } from '~/constants/getters';

// second-order references are only available for Santen Prod org; for testing purposes only, we
// can use "UZbNuMsWMxx13CiS" = Anthill (STG org). Shared allowlist for both Assist (chat) and
// authoring so the org-id list isn't duplicated across the two consumers.
const SECOND_ORDER_REFERENCE_ORG_IDS = ['SvfIMM1GaaAcSL1J', 'UZbNuMsWMxx13CiS', 'eBgUHd7dZpDmFfoG'];

export default () => {
  const store = useStore();

  const activeOrganization = computed(() => store.getters[`authStore/${GetOrganizationId}`]);

  const isSecondOrderReferencesOrg = computed(() => SECOND_ORDER_REFERENCE_ORG_IDS.includes(activeOrganization.value));

  return { isSecondOrderReferencesOrg };
};
